// extracted by mini-css-extract-plugin
export default {"mainHeader":"MainHeader_mainHeader__pjUmL","myntra":"MainHeader_myntra__g+Hgg","headerInner":"MainHeader_headerInner__I-Pbd","loginBtn":"MainHeader_loginBtn__gSwKC"};